import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DateRangePicker.vue?vue&type=style&index=0&id=39c1c99c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c1c99c"]])

export default __exports__